import React from 'react';
import phplogo from '../skill_show/php.png';
import jslogo from '../skill_show/js.png';
import reactlogo from '../skill_show/react.png';
import htmllogo from '../skill_show/html.png';
import csslogo from '../skill_show/css.png';
import sqllogo from '../skill_show/mysql.png';
import magentoImg from '../skill_show/magento.png';

export default function About() {
  return (
    <>
    <div className="aboutcontent">
        <div className="name-heading">
            <h1>Nayaab Phansopkar</h1>
            <p>Experienced PHP Backend Developer specializing in Magento framework for e-commerce solutions. Proficient in precise data manupulation through SQL queries, ensuring optimal database functionality. Skilled in crafting efficent and visually appealing front-end interfaces using HTML, CSS and jQuery. Quick learner with a knack for swiftly adapting to new technologies. Passionate about delivering high-quality, end-to-end web solutions.</p>
            <div className="social-media-links">
                <a href='https://github.com/nayaab-phansopkar' className='github-social-link' target='_blank' rel="noopener noreferrer">
                    <i className="fa-brands fa-github"></i>
                </a>
                <a href='https://www.linkedin.com/in/nayaabphansopkar/' className='linkedin-social-link' target='_blank' rel="noopener noreferrer">
                    <i className="fa-brands fa-linkedin"></i>
                </a>
                <a href='mailto:nayaabzap@gmail.com' className='gmail-social-link'>
                    <i className="fa-solid fa-square-envelope"></i>
                </a>
            </div>
        </div>
        <div className="logo-show-skills">
            <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
                <div className="carousel-inner">
                    <div className="box-content w-150px p-15px col-center carousel-item skill-logo-carousel active">
                        <img className="d-block w-100" src={phplogo} alt="PHP logo"/>
                        <span className="text-center m-t-20px skill-logo-carousel-text">PHP</span>
                    </div>
                    <div className="box-content w-150px p-15px col-center carousel-item skill-logo-carousel">
                        <img className="d-block w-100" src={jslogo} alt="JS logo"/>
                        <span className="text-center m-t-20px skill-logo-carousel-text">JavaScript</span>
                    </div>
                    <div className="box-content w-150px p-15px col-center carousel-item skill-logo-carousel">
                        <img className="d-block w-100" src={magentoImg} alt="Magento logo"/>
                        <span className="text-center m-t-20px skill-logo-carousel-text">Magento</span>
                    </div>
                    <div className="box-content w-150px p-15px col-center carousel-item skill-logo-carousel">
                        <img className="d-block w-100" src={reactlogo} alt="React logo"/>
                        <span className="text-center m-t-20px skill-logo-carousel-text">React</span>
                    </div>
                    <div className="box-content w-150px p-15px col-center carousel-item skill-logo-carousel">
                        <img className="d-block w-100" src={htmllogo} alt="HTML logo"/>
                        <span className="text-center m-t-20px skill-logo-carousel-text">HTML</span>
                    </div>
                    <div className="box-content w-150px p-15px col-center carousel-item skill-logo-carousel">
                        <img className="d-block w-100" src={csslogo} alt="CSS logo"/>
                        <span className="text-center m-t-20px skill-logo-carousel-text">css</span>
                    </div>
                    <div className="box-content w-150px p-15px col-center carousel-item skill-logo-carousel">
                        <img className="d-block w-100" src={sqllogo} alt="MySql logo"/>
                        <span className="text-center m-t-20px skill-logo-carousel-text">MySql</span>
                    </div>
                </div>
                <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="sr-only">Previous</span>
                </a>
                <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="sr-only">Next</span>
                </a>
            </div>
        </div>
    </div>
    </>
  )
}
